export default "__VITE_ASSET__DKqUZI39__"